import React, { Fragment } from "react";
import CustomPropTypes from "../utils/customPropTypes";
import PropTypes from "prop-types";
export default class ImageBlock extends React.Component {
  static propTypes = {
    image: CustomPropTypes.Image,
    addWrapper: PropTypes.bool,
    imgClassName: PropTypes.string,
    width: PropTypes.string,
    addImageAsBg: PropTypes.bool
  };
  static defaultProps = {
    addWrapper: true,
    addImageAsBg: false,
    imgClassName: "img-object"
  };

  logoStyling = {};

  constructor(props){
    super(props)
  }



  getImageHTML = () => {
    if (!this.props.image) return null;
    if (this.props.title=="Logo"){this.logoStyling = {width:"132px"}};
    if (this.props.title=="footerLogo"){this.logoStyling = {width:"180px", height:"27px"}};


    let img = (
      <img
        width={this.props.width}
        src={this.props.image.url}
        alt={this.props.image.altText}
        // style={this.logoStyling}
        className={this.props.imgClassName}

      />
    );

    if (this.props.addImageAsBg)
      img = (
        <div className={this.props.height ?  "home-banner" : "img-cover" }style={ {backgroundImage: "url("+ this.props.image.url+")", position :this.props.footerImg ? "absolute" : "", height:this.props.height? "auto !important" : "100%"} } >{img}</div>
        // <div className={this.props.height ?  "home-banner" : "img-cover" } >{img}</div>
      );
    if (this.props.addWrapper) {
      img = (
        <section className="img-section">
          <div className="container">{img}</div>
        </section>
      );
    }
    
    
    
    var logo_img = document.querySelectorAll(`.${this.props.imgClassName}`);
    if (this.props.title === "Logo") {
      logo_img.forEach(img => {
          img.setAttribute('fetchpriority', 'high');
      });
  }

    return img;
  };
  render() {
    return this.getImageHTML();
  }
}
